<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre_"><span class="calibre4"><a></a><em class="italic">Why Lazarus Laughed</em></span></p> <div class="mbp_pagebreak" id="calibre_pb_1"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?1eaba442